<h5 class="header">
  {{'ISSUE-TEXT.DOCUMENT-DETAILS' | translate}}
</h5>
<div [formGroup]="documentForm" style="margin-bottom: -1rem;">
  <div class="box-filter">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="document-no">{{'ISSUE-TEXT.DOCUMENT-NO'|translate}}</label>
          </div>
          <div class="col-md-8">
            <input class="form-control" type="text" id="document-no" formControlName="documentNo" readonly>
            <div *ngIf="documentNo.errors?.required && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
            </div>
            <div *ngIf="isDuplicateDocumentNo && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.DUP-DOC-NO' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="document-date">{{'ISSUE-TEXT.DOCUMENT-DATE'|translate}}</label>
          </div>
          <div class="col-md-8">
            <p-calendar id="document-date" formControlName="documentDate" readonlyInput="true" [showIcon]="true"
              dateFormat="dd/mm/yy" [locale]="calendarLocale" [yearNavigator]="true" yearRange="2000:2030">
            </p-calendar>
            <div *ngIf="documentDate.errors?.required && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4 text-nowrap">
            <p-checkbox class="dv-checkbox" binary="true" (onChange)="$event ? runningNo.enable() : runningNo.disable()"
              label="{{'ISSUE-TEXT.RUNNING-NO'|translate}}">
            </p-checkbox>
          </div>
          <div class="col-md-8">
            <input class="form-control" type="text" id="running-no" formControlName="runningNo">
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div *ngIf="isDeliveryOrder" class="form-group row">
          <div class="col-md-4 text-nowrap">
            <p-checkbox class="dv-checkbox" binary="true" (onChange)="$event ? orderNo.enable() : orderNo.disable()"
              label="{{'ISSUE-TEXT.ORDER-NO'|translate}}">
            </p-checkbox>
          </div>
          <div class="col-md-8">
            <input class="form-control" type="text" id="order-no" formControlName="orderNo">
          </div>
        </div>
        <div *ngIf="!isDeliveryOrder" class="form-group row">
          <div class="col-md-4 text-nowrap">
            <label for="abb-no">{{'ISSUE-TEXT.ABB-NO'|translate}}</label>
          </div>

          <div class="col-md-8">
            <ng-select formControlName="abbNo"
                [addTag]="true"
                [addTagText]="'NORMAL.ADD'|translate"
                [items]="abbData$ | async"
                [loading]="searchingAbbNo"
                bindLabel="abb_no"
                bindValue="abb_no"
                [typeahead]="abbNoInput$"
                typeToSearchText="{{'ISSUE-TEXT.SEARCHING-TEXT' | translate}}"
                [clearable]="true"
                (change)="onChangeAbbNo($event)">
            </ng-select>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="!isCreditNote && enabledCustomerRequest">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="document-request">{{'ISSUE-TEXT.DOCUMENT-REQUEST'|translate}}</label>
          </div>
          <div class="col-md-8">
            <ng-select formControlName="documentRequest"
                [items]="documentRequests$ | async"
                [loading]="searchingDocumentRequest"
                bindLabel="request_no"
                bindValue="id"
                [typeahead]="documentRequestInput$"
                typeToSearchText="{{'ISSUE-TEXT.SEARCHING-TEXT' | translate}}"
                [clearable]="true"
                (change)="onChangeDocumentRequest($event)">
            </ng-select>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="!isCreditNote && enabledCustomerRequest">
        <div class="form-group row">
          <div class="col-md-4 text-nowrap">
            <p-checkbox class="dv-checkbox"
                [binary]="true"
                [(ngModel)]="confirmationNoChecked"
                [ngModelOptions]="{standalone: true}"
                (onChange)="$event ? confirmationNo.enable() : confirmationNo.disable();"
                label="{{'ISSUE-TEXT.CONFIRMATION-NO'|translate}}">
            </p-checkbox>
          </div>
          <div class="col-md-8">
            <input class="form-control" type="text" id="confirmation-no" formControlName="confirmationNo">
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="enabledCustomerRequest">
        <div class="form-group row">
          <div class="col-md-4">
            <label>{{'ISSUE-TEXT.DEPARTMENT'|translate}}</label>
          </div>
          <div class="col-md-8">
            <p-dropdown class="dv-dropdown" id="department" selectId="department" [options]="departments"
              formControlName="department" [autoDisplayFirst]="false" placeholder="{{'HISTORY.DEPARTMENT'|translate}}"
              (onChange)="changeDepartment($event)">
            </p-dropdown>
            <div *ngIf="department.errors?.required && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div *ngIf="isDeliveryOrder" class="form-group row">
          <div class="col-md-auto text-nowrap">
            <p-checkbox class="dv-checkbox"
                [binary]="true"
                [(ngModel)]="abbNoChecked"
                [ngModelOptions]="{standalone: true}"
                (onChange)="$event ? abbNo.enable() : abbNo.disable()"
                label="{{'ISSUE-TEXT.ABB-NO'|translate}}">
            </p-checkbox>
          </div>
          <div class="col-md">
            <input class="form-control" type="text" id="abb-no" formControlName="abbNo">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="box-parent">
    <h6>{{'ISSUE-TEXT.REF-DOC' | translate}}</h6>
    <div class="row">
      <div class="col-12">
        <div formArrayName="referenceDocuments">
          <div *ngFor="let referenceDocument of referenceDocuments.controls; let i=index">
            <div [formGroupName]="i">
              <div class="row">
                <div class="col-md">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="reference-document-no">{{'ISSUE-TEXT.REF-ID'|translate}}</label>
                        <input class="form-control" id="reference-document-no" formControlName="documentNo">
                        <div *ngIf="getReferenceDocumentNo(i).errors?.required && isSubmitted">
                          <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="reference-document-type">{{'ISSUE-TEXT.REF-TYPE'|translate}}</label>
                        <p-dropdown class="dv-dropdown" id="reference-document-type" selectId="documentType"
                          [options]="documentTypes" formControlName="documentType" [autoDisplayFirst]="false"
                          placeholder="{{'FILTER.PLACEHOLDER' | translate}}">
                        </p-dropdown>
                        <div *ngIf="getReferenceDocumentType(i).errors?.required && isSubmitted">
                          <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="reference-document-date">{{'ISSUE-TEXT.REF-DATE'|translate}}</label>
                        <p-calendar formControlName="documentDate" id="reference-document-date" readonlyInput="true"
                          [showIcon]="true" dateFormat="dd/mm/yy" [locale]="calendarLocale" [yearNavigator]="true"
                          yearRange="2000:2030"></p-calendar>
                        <div *ngIf="getReferenceDocumentDate(i).errors?.required && isSubmitted">
                          <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-auto align-self-end" *ngIf="isCreditNote || isDebitNote"
                  [ngStyle]="{'visibility': (i !== 0) ? 'visible' : 'hidden'}">
                  <button class="ui-button bg-danger border-danger ui-button-icon-only"
                    style="margin-bottom: calc(1rem + 10px)" (click)="removeReferenceDocument(i)">
                    <em class="fa fa-trash-alt"></em>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="isCreditNote || isDebitNote">
        <div class="form-group">
          <button class="ui-button" style="padding: 5px; border-radius: 5px;" (click)="addReferenceDocument()">
            <em class="fa fa-plus"></em>
            <span>{{'ISSUE-TEXT.ADD-REF-DOC' | translate}}</span>
          </button>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group row">
          <div class="col-md-2">
            <label for="purpose">{{'ISSUE-TEXT.PURPOSE'|translate}}</label>
          </div>
          <div class="col-md-10">
            <input class="form-control" type="text" id="purpose" formControlName="purpose">
            <div *ngIf="purpose.errors?.required && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/document-form/document-form.component.html